import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { Error } from "@mui/icons-material";

export function showInvalidItemsAlert(kind: string, functionOnclose?: Function, functionOnConfirmation?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: [`Altere a quantidade de módulo para respeitar as especificações do ${kind}.`],
    size: '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    subtitle:'',
    onClose: () => {
      if(functionOnclose) functionOnclose();
      confirmationDialog.close();
    },
    onConfirmation: () => {
      if(functionOnConfirmation) functionOnConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();
}